import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "alarm",
  "use": "alarm-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"alarm\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M2 6a6 6 0 1 1 12 0v7H2V6zm2 2a1 1 0 0 1 2 0v2a1 1 0 1 1-2 0V8zm-3 6a1 1 0 1 0 0 2h14a1 1 0 1 0 0-2H1z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol